import React from 'react';

import './index.scss';

//api
import {api} from '../../functions/api';

//material-ui
import { CircularProgress} from '@material-ui/core';

//custom components
import CustomTable from '../../components/complex/customTable';
import CustomButton from '../../components/basic/CustomButton';
import Search from '../../components/basic/search';
import DeleteDialog from '../../components/global/deleteDialog';

//other libraries
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';
import queryString from 'query-string'
import Icon from '@mdi/react'
import {mdiPlus} from '@mdi/js'

@inject('internal')
@inject('translate')
@observer
export default class Templates extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            loading: true,
            message: "",
            openSnackbar: false,
            openAddDialog: false,
        }
    }

    componentDidMount() {
        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            && toJS(this.props.internal.user.data.permissions)
            && toJS(this.props.internal.user.data.permissions.lists_email_templates)
            && toJS(this.props.internal.user.data.permissions.lists_email_templates.view)){

            this.props.internal.setRoute( this.props.history, this.props.location.pathname);
            this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.HEADER.TEMPLATES);
            this.loadTemplates();
            this.setPermissions();
        }
        else {
            this.props.internal.setRoute( this.props.history, this.props.location.pathname);
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    tableHeader = [
        {
            "title": "name",
            "numeric": false
        },
        {
            "title": "alias",
            "numeric": false,
            textAlign: "left"
        },
    ];
    tableBody = ["name", "alias"]

    dropDownMenuItems = [
        
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
        //     url: "edit"
        // },
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
        //     action: "delete"
        // },
    ]

    setPermissions () {
        this.dropDownMenuItems = []
        let permissions = toJS(this.props.internal.user.data.permissions.lists_email_templates);
        if(permissions.update) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
                    url: "edit"
                },
            )
        }
        if(permissions.destroy) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
                    action: "delete"
                },
            )
        }
    }

    loadTemplates = async(size = 10, page = 0, searchterm = " ", by = "name", dir = "asc") => {

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let params = {
            searchterm: searchterm,
            page: {
                number: page,
                size: size
            },
            order: [
                {
                    by: by,
                    dir: dir
                }
            ]
        }
        let load_data = await api({
            method: 'get',
            url: 'lists/email-templates',
            authorization: this.props.internal.user.access_token,
            params: params
        })

        if(load_data.success === true) {
            
            this.props.internal.setDataForTable(load_data.data)
            
        }
        this.setState({loading: false})
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else {
            this.addQueryToUrl("searchterm", "")
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
        // this.addQueryToUrl("by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }
        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key && queries[key] !== "") {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadTemplates();
    }

    //dorobit pre tennto modul
    handleDelete = async () => {
        let id = toJS(this.props.internal.actionDeleteObj.id)
        let delete_template = await api({
            method: 'delete',
            url: `lists/email-templates/${id}`,
            authorization: this.props.internal.user.access_token,
        });

        if(delete_template.success === true) {
            this.props.internal.setSnackbar(delete_template.data.message, true)
            this.loadTemplates();
            this.props.internal.setActionDelete();
        }
        else {
            let resultError = "";
            if(delete_template.data.data.errors) {
                for(let error in delete_template.data.data.errors){
                    resultError += delete_template.data.data.errors[error] + " "
                }
            }
            this.props.internal.setSnackbar(resultError, true)
        }
    }

    createNewTemplate = () => {
        
        this.props.internal.pushRoute("/templates/new")
    }

    render() {
        let permissions = toJS(this.props.internal.user.data.permissions.lists_email_templates);
        const routerData = {
            history: this.props.history,
            location: this.props.location,
            match: this.props.match
        }
        return (
            this.state.loading
                ?
                <CircularProgress className={'circular-progress'} />
                :
                <div className={'templates-list'}>
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES.TEMPLATES.DELETE_TEMPLATE_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                    <div className={'flex space-between'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.TAGS.SEARCH} classes={'products-search-box'} onChange={this.handleSearch} value={this.state.searchTerm } routerData={routerData}/>
                        {permissions.store ?
                            <CustomButton
                            mystyle={'btn-orange-bg border-radius-18'}
                                title={this.props.translate.i18n.MODULES.TEMPLATES.CREATE_NEW_TEMPLATE}
                                onClick={this.createNewTemplate}
                            >
                                <Icon path={mdiPlus} size={1}  />
                            </CustomButton>
                            :
                            null
                        }
                    </div>
                    <CustomTable
                        //customStyle={'templates-table'}
                        dropDownMenuItems = {this.dropDownMenuItems}
                        module = {'/templates'}
                        handleChangeRowsPerPage = {this.handleChangeRowsPerPage}
                        handleChangePage = {this.handleChangePage}
                        handleSort = {this.handleSort}
                        header = {this.tableHeader}
                        body = {this.tableBody}
                    />

                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/templates/index.js